import { useState } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import durationPlugin from 'dayjs/plugin/duration';

import useConfig from 'src/hooks/useConfig';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useUpdateEffect } from 'react-use';

const loadLocaleData = (locale) => {
	switch (locale) {
		case 'ru':
			return import('src/utils/locales/ru.json');
		case 'en':
		default:
			return import('src/utils/locales/en.json');
	}
};

const initialLocale = 'ru';
dayjs.extend(durationPlugin);
dayjs.locale(initialLocale);

const Locales = ({ children }) => {
	const { defaultMessages } = useConfig();
	const i18n = initialLocale; // TODO: add switcher

	const [messages, setMessages] = useState(defaultMessages);

	useUpdateEffect(() => {
		loadLocaleData(i18n).then((d) => {
			dayjs.locale(i18n);
			setMessages(d.default);
		});
	}, [i18n]);

	return (
		<>
			{messages && (
				<IntlProvider
					locale={i18n}
					defaultLocale={initialLocale}
					messages={messages}
				>
					<LocalizationProvider
						dateAdapter={AdapterDayjs}
						adapterLocale={i18n || initialLocale}
					>
						{children}
					</LocalizationProvider>
				</IntlProvider>
			)}
		</>
	);
};

Locales.propTypes = { children: PropTypes.node };

export default Locales;
